<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card class="pa-4">
    <div class="d-flex align-center">
      <div class="text-h3">
        <span>{{ editIndex === -1 ? $t('add') : $t('edit') }}</span>
      </div>
      <v-spacer />
      <div>
        <v-btn
          icon
          @click="$emit('close')"
        >
          <v-icon large>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div class="d-flex justify-center align-center">
      <v-card
        class="mt-2"
        color="#c0c0c0"
        elevation="0"
        height="150px"
        style="position: relative"
        width="150px"
        @click="startUpload"
      >
        <div>
          <v-card
            color="#f6f6f6"
            elevation="0"
            width="fit-content"
          >
            <v-img
              :src="showPic"
              height="150px"
              style="border-radius: 12px"
              width="150px"
            />
          </v-card>
          <v-file-input
            ref="file"
            accept="image/*"
            class="mt-2"
            counter
            dense
            height="150px"
            outlined
            style="opacity: 0;cursor: pointer"
            width="150px"
            @change="processFile"
          />
          <v-btn
            absolute
            bottom
            color="amber lighten-4 black--text"
            fab
            style="right: -12px"
            x-small
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-card>
    </div>
    <v-card
      class="pa-4 mt-6"
      outlined
    >
      <div class="text-h4">
        {{ $t('basicInformation') }}
      </div>
      <div class="mt-2 d-flex justify-end align-end">
        <v-tabs
          v-model="langTab"
          color="#232123"
          height="36px"
          show-arrows
          style="background: transparent!important;"
        >
          <v-tab
            v-for="(item,i) in items"
            :key="item.id"
          >
            {{ $t(item.lang.toLowerCase()) }}
            <span
              v-if="i===0"
              class="red--text"
            > * </span>
          </v-tab>
        </v-tabs>
      </div>
      <div class="mt-2">
        <v-tabs-items v-model="langTab">
          <v-tab-item
            v-for="(item,index) in items"
            :key="item.id"
          >
            <div>
              <span>{{ $t('name') }}</span><span
                v-if="index === 0"
                style="color: red"
              >*</span>
            </div>
            <v-text-field
              v-model="item.name"
              class="mt-2"
              outlined
            />
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div>
        <div>
          <span>{{ $t('price') }}</span><span style="color: red">*</span>
        </div>
        <v-text-field
          v-model="price"
          class="mt-2"
          outlined
        />
      </div>
    </v-card>
    <div class="d-flex">
      <v-spacer />
      <v-btn
        :disabled="items[0].name === '' || price === ''"
        :loading="btnLoading"
        class="amber lighten-4 black--text my-2"
        elevation="0"
        outlined
        @click="save"
      >
        {{ $t('save') }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>

import GlobalSettings, { getRootUrl } from '@/model/global/GlobalSettings'
import { showSuccessMessage } from '@/model/utils/utils'
import Attribute from '@/model/dataLayer/api/dish/Attribute'

export default {
  name: 'EditAttributeDialog',
  props: {
    dialogDisplay: {},
    addForAll: {},
    editIndex: {},
    attributeGroup: {},
    editItemInfo: {}
  },
  data () {
    return {
      btnLoading: false,
      showPic: null,
      price: '',
      langs: [],
      itemPic: null,
      langTab: null,
      items: [
        {
          id: 1,
          lang: 'de',
          name: ''
        }, {
          id: 2,
          lang: 'zh',
          name: ''
        }, {
          id: 3,
          lang: 'en',
          name: ''
        }
      ]
    }
  },
  computed: {
    imagePath () {
      return getRootUrl() + GlobalSettings.dcImageRoot
    }
  },
  watch: {
    dialogDisplay: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.items = [
            {
              id: 1,
              lang: 'de',
              name: ''
            }, {
              id: 2,
              lang: 'zh',
              name: ''
            }, {
              id: 3,
              lang: 'en',
              name: ''
            }
          ]
          this.price = ''
          this.showPic = null
          this.itemPic = null
        }
      }
    },
    editIndex: {
      deep: true,
      immediate: true,
      handler (val) {
        console.log(val, 'val')
        if (val !== -1) {
          this.items = this.editItemInfo.langs.slice(0, 3)
          this.price = this.editItemInfo.priceMod
          this.showPic = this.imagePath + this.editItemInfo.image
          this.itemPic = this.editItemInfo.image
        } else {
          this.items = [
            {
              id: 1,
              lang: 'de',
              name: ''
            }, {
              id: 2,
              lang: 'zh',
              name: ''
            }, {
              id: 3,
              lang: 'en',
              name: ''
            }
          ]
          this.price = ''
          this.showPic = null
          this.itemPic = null
        }
      }
    }
  },
  async mounted () {
  },
  methods: {
    startUpload () {
      this.$refs.file.$refs.input.click()
    },
    processFile (event) {
      this.itemPic = event
      this.showPic = URL.createObjectURL(event)
    },
    async save () {
      this.btnLoading = true
      if (this.items[1].name === '') {
        this.items[1].name = this.items[0].name
      }
      if (this.items[2].name === '') {
        this.items[2].name = this.items[0].name
      }
      if (this.editIndex === -1) {
        if (this.addForAll !== 1) {
          const res = {
            name: this.items[0].name,
            langs: this.items,
            file: this.itemPic,
            priceMod: this.price,
            attributeGroupId: this.attributeGroup.id,
            printMod: this.items[1].name,
            dishesCategoryTypeId: 10
          }
          await Attribute.add(res)
          await showSuccessMessage(this.$t('addSuccess'))
        } else {
          for (const id of [-1001, -1002, -1003]) {
            const res = {
              name: this.items[0].name,
              langs: this.items,
              file: this.itemPic,
              priceMod: this.price,
              attributeGroupId: id,
              printMod: this.items[1].name,
              dishesCategoryTypeId: 10
            }
            await Attribute.add(res)
            await showSuccessMessage(this.$t('addSuccess'))
          }
        }
      } else {
        const res = {
          name: this.items[0].name,
          langs: this.items,
          file: this.itemPic,
          priceMod: this.price,
          attributeGroupId: this.attributeGroup.id,
          printMod: this.items[1].name,
          dishesCategoryTypeId: this.editItemInfo.dishesCategoryTypeId,
          id: this.editItemInfo.id
        }
        await Attribute.edit(res)
        await showSuccessMessage(this.$t('EditSuccess'))
      }
      await this.$emit('close')
      this.btnLoading = false
    }
  }
}
</script>

<style scoped>

</style>
